import { Link } from '@tanstack/react-router';
import {
  ENV_CROSS_LINK_TO_CARBON_PLANNING,
  ENV_DASHBOARD_FOOTER_DISCLOSURE,
  ESG_LOCATION_BASED_METHOD_BADGE,
  ESG_LOCATION_BASED_METHOD_NOTE,
} from '@siliconx/shared';

/**
 * SIL-459 design-deviation register — mandatory footer on EVERY tab of the
 * Environmental dashboard (Overview, Fleet detail, Circularity, Reports):
 * the disclosure line + a "Location-based method" chip whose tooltip is
 * the sil-426 §2 string VERBATIM (imported from dto/esg-export.ts, never
 * retyped). NEVER the mock's "Scope 2 market-based" / "third-party
 * assured" wording — that copy was never legally vetted for this surface.
 *
 * SIL-486 (sustainability-dashboard-spec.md §1): also carries the one-line
 * cross-link to Carbon Planning (the forward-looking counterpart to this
 * backward-looking dashboard), rendering on every tab via this shared
 * footer.
 *
 * SIL-611: the Regulatory-register cross-link used to live here. It moved to
 * the TOP of the page (rendered by the `/environmental` layout above the tab
 * bar) so it is visible without scrolling — matching the design doc's
 * "one line under the header" placement. Do not re-add it here; it would then
 * render twice on every tab.
 */
export function EnvironmentalFooter() {
  return (
    <div className="flex flex-col gap-2 border-t border-zinc-200 pt-3.5 text-xs text-zinc-500">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span>{ENV_DASHBOARD_FOOTER_DISCLOSURE}</span>
          <span
            title={ESG_LOCATION_BASED_METHOD_NOTE}
            className="inline-flex cursor-default items-center rounded border border-zinc-300 bg-white px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-zinc-600"
            data-testid="location-based-method-chip"
          >
            {ESG_LOCATION_BASED_METHOD_BADGE}
          </span>
        </div>
        <Link to="/financials/sustainability" className="text-brand-700 hover:underline" data-testid="cross-link-carbon-planning">
          {ENV_CROSS_LINK_TO_CARBON_PLANNING}
        </Link>
      </div>
    </div>
  );
}
